import { MDText } from 'i18n-react';

import {
	CameraIcon,
	HeatedSeatsIcon,
	MoneyTagIcon,
	NavigationIcon,
	PanoramicRoofIcon,
	UpgradedSoundSystemIcon,
} from '@motorway/motorway-storybook-cra';

import vehicleFeaturesSectionTexts from '../VehicleFeaturesSection.texts';

const LocalT = new MDText(vehicleFeaturesSectionTexts.list);

export const DEFAULT_FEATURE_ICON = <MoneyTagIcon />;
export const MAX_VISIBLE_FEATURES_STANDARD = 5;
export const MAX_VISIBLE_FEATURES_ADDITIONAL = 3;

export const STANDARD_FEATURES = Object.freeze({
	heatedSeats: {
		icon: <HeatedSeatsIcon />,
		key: 'heated_seats',
		label: `${LocalT.translate('heatedSeats')}`,
	},
	panoramicRoof: {
		icon: <PanoramicRoofIcon />,
		key: 'panoramic_roof',
		label: `${LocalT.translate('panoramicRoof')}`,
	},
	parkingCam: {
		icon: <CameraIcon />,
		key: 'parking_cam',
		label: `${LocalT.translate('parkingCamera')}`,
	},
	satNav: {
		icon: <NavigationIcon />,
		key: 'sat_nav',
		label: `${LocalT.translate('satNav')}`,
	},
	soundSystem: {
		icon: <UpgradedSoundSystemIcon />,
		key: 'sound_system',
		label: `${LocalT.translate('upgradedSoundSystem')}`,
	},
});

export const STANDARD_FEATURES_ORDER = ['sat_nav', 'panoramic_roof', 'heated_seats', 'parking_cam', 'sound_system'];

export const VEHICLE_DETAILS_TITLE = 'Vehicle details';

export const FEATURES_LIST_EVENTS = {
	featuresModalClosed: 'Features modal closed',
	featuresViewAllLinkClicked: 'View all features link clicked',
} as const;
